import { useState, useEffect, useRef, useCallback } from 'react';
import { FlexGrid, FlexGridColumn } from '@grapecity/wijmo.react.grid';
import { Button, Card, Form, Row, Col } from 'react-bootstrap';
import { DataMap } from '@grapecity/wijmo.grid';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { checkRequired } from 'utils/validationUtils';
import TextComponent from 'components/Input/TextComponent';
import { useRestApi } from 'context/RestApiContext';
import { InputDate, AutoComplete } from '@grapecity/wijmo.input';
import { CollectionView } from '@grapecity/wijmo';
import { CardReturnBiko } from 'constants/constants';
import { useMaster } from 'context/MasterContext';
import './InspectionScheduleEditModal.css';

function InspectionScheduleEditModal(props) {
  const restApi = useRestApi();
  // マスタ情報
  const master = useMaster();
  // アフター情報
  const [inspection, setInspection] = useState({});

  // 確認ダイアログ
  const [dialog, setDialog] = useState({});
  // エラーフィールド
  const [errorFileds, setErrorFileds] = useState([]);

  // モーダルの表示
  const [show, setShow] = useState(false);

  const flexGridRef = useRef(null);

  // モーダルパラメタの変更処理
  useEffect(() => {
    if (props?.params?.inspectionData) {
      const data = props.params.inspectionData;

      // 1行を3点検に分割
      const detailList = [
        {
          ENABLE: !!data.M6_INSPECTION_FLG,
          TYPE: '6箇月点検',
          PLAN: data.M6_PLAN ? new Date(data.M6_PLAN) : null,
          CARD_SEND: data.M6_CARD_SEND ? new Date(data.M6_CARD_SEND) : null,
          CARD_RETURN: data.M6_CARD_RETURN ? new Date(data.M6_CARD_RETURN) : null,
          CARD_RETURN_BIKO: data.M6_CARD_RETURN_BIKO || '',
          INSPECT_DATE: data.M6_INSPECT_DATE ? new Date(data.M6_INSPECT_DATE) : null,
          INSPECT_TAN: data.M6_INSPECT_TAN,
          BIKO: data.M6_BIKO || '',
          INSPECTION_TYPE_CD: 1,
        },
        {
          ENABLE: !!data.Y1_INSPECTION_FLG,
          TYPE: '1年点検',
          PLAN: data.Y1_PLAN ? new Date(data.Y1_PLAN) : null,
          CARD_SEND: data.Y1_CARD_SEND ? new Date(data.Y1_CARD_SEND) : null,
          CARD_RETURN: data.Y1_CARD_RETURN ? new Date(data.Y1_CARD_RETURN) : null,
          CARD_RETURN_BIKO: data.Y1_CARD_RETURN_BIKO || '',
          INSPECT_DATE: data.Y1_INSPECT_DATE ? new Date(data.Y1_INSPECT_DATE) : null,
          INSPECT_TAN: data.Y1_INSPECT_TAN,
          BIKO: data.Y1_BIKO || '',
          INSPECTION_TYPE_CD: 2,
        },
        {
          ENABLE: !!data.Y3_INSPECTION_FLG,
          TYPE: '3年点検',
          PLAN: data.Y3_PLAN ? new Date(data.Y3_PLAN) : null,
          CARD_SEND: data.Y3_CARD_SEND ? new Date(data.Y3_CARD_SEND) : null,
          CARD_RETURN: data.Y3_CARD_RETURN ? new Date(data.Y3_CARD_RETURN) : null,
          CARD_RETURN_BIKO: data.Y3_CARD_RETURN_BIKO || '',
          INSPECT_DATE: data.Y3_INSPECT_DATE ? new Date(data.Y3_INSPECT_DATE) : null,
          INSPECT_TAN: data.Y3_INSPECT_TAN,
          BIKO: data.Y3_BIKO || '',
          INSPECTION_TYPE_CD: 3,
        },
      ];

      setInspection(data); // もともとの1行分のデータ
      setAfterDetails(new CollectionView(detailList)); // グリッド用3行データ
      setShow(true);
    }
  }, [props.params]);

  // 編集処理
  const handleChange = (prop) => (target) => {
    setInspection({ ...inspection, [prop]: target?.value ?? target?.target.value });
  };
  const toMysqlDate = (dateStr) => {
    if (!dateStr) return null;
    const d = new Date(dateStr);
    return d.toISOString().slice(0, 10); // 'YYYY-MM-DD'
  };

  // 確定ボタン
  const handleFix = () => {
    // 編集用3行データ
    const details = afterDetails.sourceCollection;

    // inspectionをコピー
    const mergedInspection = { ...inspection };

    details.forEach((item) => {
      const prefix =
        item.INSPECTION_TYPE_CD === 1 ? 'M6' : item.INSPECTION_TYPE_CD === 2 ? 'Y1' : 'Y3';

      mergedInspection[`${prefix}_INSPECTION_FLG`] = item.ENABLE ? 1 : 0;
      mergedInspection[`${prefix}_PLAN`] = toMysqlDate(item.PLAN) || null;
      mergedInspection[`${prefix}_CARD_SEND`] = toMysqlDate(item.CARD_SEND) || null;
      mergedInspection[`${prefix}_CARD_RETURN`] = toMysqlDate(item.CARD_RETURN) || null;
      mergedInspection[`${prefix}_CARD_RETURN_BIKO`] = item.CARD_RETURN_BIKO || '';
      mergedInspection[`${prefix}_INSPECT_DATE`] = toMysqlDate(item.INSPECT_DATE) || null;
      mergedInspection[`${prefix}_INSPECT_TAN`] = item.INSPECT_TAN || null;
      mergedInspection[`${prefix}_BIKO`] = item.BIKO || '';
    });

    restApi.post(
      '/api/inspectionScheduleList/upd',
      mergedInspection,
      (_) => {
        if (!props.params.call_list) {
          props.callbak();
        } else {
          props.params.callback(mergedInspection);
        }
        setShow(false);
      },
      true
    );
  };

  const planerWithEmpty = [...master.planer, { id: 0, name: '' }];
  const planerMap = new DataMap(planerWithEmpty, 'id', 'name');

  // 閉じるボタン処理
  const handleClose = () => {
    setShow(false);
  };

  // アフター明細
  const [afterDetails, setAfterDetails] = useState(new CollectionView([]));

  // グリッドの初期化処理
  const handleInitialized = useCallback((flexGrid) => {
    flexGrid.columns.forEach((col) => {
      // PLANだけ yyyy/MM で月選択
      if (col.binding === 'PLAN') {
        const inputDate = new InputDate(document.createElement('div'), {
          format: 'yyyy/MM',
          selectionMode: 'Month',
          isRequired: false,
          showYearPicker: true,
        });
        // UTC変換時に日付がずれないように、時間を正午に設定
        inputDate.valueChanged.addHandler(() => {
          if (inputDate.value) {
            const d = inputDate.value;
            inputDate.value = new Date(d.getFullYear(), d.getMonth(), 1, 12);
          }
        });

        inputDate.textChanged.addHandler(() => {
          if (inputDate.text.trim() === '') {
            inputDate.value = null;
          }
        });

        inputDate.hostElement.classList.add('grid-selector');
        col.editor = inputDate;
      }

      // その他の日付列（通常のカレンダー）
      else if (
        col.binding === 'CARD_SEND' ||
        col.binding === 'CARD_RETURN' ||
        col.binding === 'INSPECT_DATE'
      ) {
        const inputDate = new InputDate(document.createElement('div'), {
          format: 'yyyy/MM/dd',
          isRequired: false,
        });

        inputDate.invalidInput.addHandler(() => {
          const value = inputDate.text.trim();
          if (isValidDate(value)) {
            const [month, day] = value.split('/').map(Number);
            const currentYear = new Date().getFullYear();
            // UTC変換時に日付がずれないように、時間を正午に設定
            const d = new Date(currentYear, month - 1, day);
            d.setHours(12, 0, 0, 0);
            inputDate.value = d;
          }
        });
        const isValidDate = (d) => {
          const date = new Date(d);
          return d && !isNaN(date);
        };

        // UTC変換時に日付がずれないように、時間を正午に設定
        inputDate.valueChanged.addHandler(() => {
        const v = inputDate.value;
          if (v) {
            const d = new Date(v.getFullYear(), v.getMonth(), v.getDate(), 12, 0, 0, 0);
            inputDate.value = d;
          }
        });
        inputDate.textChanged.addHandler(() => {
          if (inputDate.text.trim() === '') {
            inputDate.value = null;
          }
        });

        inputDate.hostElement.classList.add('grid-selector');
        col.editor = inputDate;
      }

      // 返信備考（AutoComplete）
      if (col.binding === 'CARD_RETURN_BIKO') {
        const comboBox = new AutoComplete(document.createElement('div'), {
          itemsSource: CardReturnBiko.map((item) => item.value),
        });
        comboBox.hostElement.classList.add('grid-selector');
        col.editor = comboBox;
      }
    });
  }, []);

  // グリッドの選択時の処理（IME制御）
  const gridSelectionChanged = (grid, args) => {
    const col = grid.columns[args.col];

    // 日付の場合はimeをoffにする
    const imeEnabled = !['PLAN', 'CARD_SEND', 'CARD_RETURN', 'INSPECT_DATE'].includes(
      col?.binding
    );
    setTimeout(() => {
      grid.imeEnabled = imeEnabled;
    }, 50);
  };

  return (
    <>
      <Dialog fullWidth={true} maxWidth="xl" open={show} disableEnforceFocus={true}>
        <DialogTitle className="p-3">アフター状況編集</DialogTitle>
        <DialogContent className="px-0 py-0 pr-0 pl-0">
          <Card className="m-0">
            <Card.Body>
              <Col className="pl-3 pt-3" md="2">
                <b>＜顧客情報＞</b>
              </Col>
              <Row>
                <Col className="pr-1" md="2">
                  <Form.Group>
                    <label>顧客名</label>
                    <TextComponent
                      value={inspection.NAME_1}
                      type="text"
                      disabled={true}
                    ></TextComponent>
                  </Form.Group>
                </Col>
                <Col className="pr-1" md="1">
                  <Form.Group>
                    <label>郵便番号</label>
                    <TextComponent
                      value={inspection.POST_CODE}
                      type="text"
                      disabled={true}
                    ></TextComponent>
                  </Form.Group>
                </Col>
                <Col className="pr-1" md="4">
                  <Form.Group>
                    <label>住所</label>
                    <TextComponent
                      value={inspection.FULL_ADDRESS}
                      type="text"
                      disabled={true}
                    ></TextComponent>
                  </Form.Group>
                </Col>
                <Col className="pr-1" md="2">
                  <Form.Group>
                    <label>電話番号</label>
                    <TextComponent
                      value={`${inspection.TEL1}${
                        inspection.TEL_RELATION_1 ? `（${inspection.TEL_RELATION_1}）` : ''
                      }`}
                      type="text"
                      disabled={true}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Col className="pl-3 pt-3" md="2">
                <b>＜工事情報＞</b>
              </Col>
              <Row>
                <Col className="pr-1" md="2">
                  <Form.Group>
                    <label>営業担当</label>
                    <TextComponent
                      value={
                        planerWithEmpty.find((p) => p.id === inspection.SALES_TAN_CD)?.name || ''
                      }
                      type="text"
                      disabled={true}
                    ></TextComponent>
                  </Form.Group>
                </Col>
                <Col className="pr-1" md="2">
                  <Form.Group>
                    <label>現場担当</label>
                    <TextComponent
                      value={
                        planerWithEmpty.find((p) => p.id === inspection.GENBA_TAN_CD)?.name || ''
                      }
                      type="text"
                      disabled={true}
                      dataMap={planerMap}
                    ></TextComponent>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col className="pr-1" md="2">
                  <Form.Group>
                    <label>契約番号</label>
                    <TextComponent
                      value={inspection.CONTRACT_NUMBER}
                      type="text"
                      disabled={true}
                    ></TextComponent>
                  </Form.Group>
                </Col>
                <Col className="pr-1" md="2">
                  <Form.Group>
                    <label>引渡日</label>
                    <TextComponent
                      value={inspection.HIKI_DATE_FORMAT}
                      type="text"
                      disabled={true}
                    ></TextComponent>
                  </Form.Group>
                </Col>
                <Col className="pr-1" md="3">
                  <Form.Group>
                    <label>工事内容</label>
                    <TextComponent
                      value={inspection.IRAI_MEI}
                      type="text"
                      disabled={true}
                    ></TextComponent>
                  </Form.Group>
                </Col>
              </Row>
              <Col className="pl-3 pt-3" md="2">
                <b>＜アフター情報＞</b>
              </Col>
              <Row className="pl-2 pt-2">
                <Col md="2">
                  <label>アフターNo</label>
                </Col>
              </Row>
              <Row className="pt-1">
                <Col md="2">
                  <TextComponent
                    type="numberString"
                    value={inspection.AFTER_NUMBER}
                    maxLength={7}
                    className="text-right"
                    onChange={handleChange('AFTER_NUMBER')}
                  ></TextComponent>
                </Col>
              </Row>
              <Row className="pt-2">
                <Col id="afterGrid" className="pt-0 pl-3">
                  <FlexGrid
                    itemsSource={afterDetails}
                    ref={flexGridRef}
                    allowSorting={false}
                    initialized={handleInitialized}
                    loadedRows={(grid) => {
                      grid.rows.forEach((ele) => {
                        ele.height = 38;
                      });
                    }}
                    imeEnabled={true}
                    selectionChanged={gridSelectionChanged}
                    >
                    <FlexGridColumn
                      binding="ENABLE"
                      header="実施"
                      width={80}
                      isReadOnly={false}
                      dataType="Boolean"
                    />
                    <FlexGridColumn
                      binding="TYPE"
                      cssClass="cell-readonly"
                      isReadOnly={true}
                      header="点検"
                      width={90}
                    />
                    <FlexGridColumn
                      binding="PLAN"
                      header="点検予定月"
                      format="yyyy/MM"
                      isRequired={false}
                      width={130}
                    />
                    <FlexGridColumn
                      binding="CARD_SEND"
                      header="葉書発送"
                      isRequired={false}
                      width={150}
                    />
                    <FlexGridColumn
                      binding="CARD_RETURN"
                      header="葉書返信"
                      isRequired={false}
                      width={150}
                      format="yyyy/MM/dd"
                    />
                    <FlexGridColumn binding="CARD_RETURN_BIKO" header="返信備考" width={150} />
                    <FlexGridColumn
                      binding="INSPECT_DATE"
                      header="点検実施日"
                      isRequired={false}
                      width={150}
                    />
                    <FlexGridColumn
                      binding="INSPECT_TAN"
                      header="実施担当"
                      width={120}
                      dataMap={planerMap}
                    />
                    <FlexGridColumn binding="BIKO" header="備考" width={'*'} />
                  </FlexGrid>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </DialogContent>
        <DialogActions className="p-3" style={{ justifyContent: 'space-between' }}>
          <Button variant="secondary" className="footer-button" onClick={handleClose}>
            閉じる
          </Button>
          <Button variant="primary btn-fill" className="footer-button" onClick={handleFix}>
            更新
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default InspectionScheduleEditModal;
